import { useEffect } from 'react';
import { useLocation } from 'react-router-dom-v5-compat';

import { getQueryParamValue } from 'src/lib/browser';
import { ROUTE_PARAMS } from 'src/routes';

import { useLocalActions } from '../store';

const getTextToImprove = (location) => {
  // Support links from "Infinity" extension
  const queryValue = getQueryParamValue(ROUTE_PARAMS.textToImprove, location.search);
  if (queryValue) {
    return decodeURIComponent(queryValue);
  }

  return location.state?.textToImprove;
};

const getKeywords = (location) => {
  // Support links from "Infinity" extension
  const queryValue = getQueryParamValue(ROUTE_PARAMS.keywords, location.search);
  if (queryValue) {
    return decodeURIComponent(queryValue).split(',');
  }

  return location.state?.keywords;
};

export const useSupportTextToImprove = () => {
  const location = useLocation();
  const localActions = useLocalActions();

  // Check current URL, and fill rewrite input with the text and campaign keywords
  useEffect(() => {
    const textToImprove = getTextToImprove(location);
    const keywords = getKeywords(location);
    if (textToImprove) {
      localActions.updateRewriteText(textToImprove);
    }
    if (keywords) {
      localActions.createMultipleAnnotations(keywords);
    }
  }, [location, localActions]);
};
